import { frontendURL } from 'dashboard/helper/URLHelper.js';

import CampaignsPageRouteView from './pages/CampaignsPageRouteView.vue';
import LiveChatCampaignsPage from './pages/LiveChatCampaignsPage.vue';
import WhatsAppCampaignsPage from './pages/WhatsAppCampaignsPage.vue';
import APICampaignsPage from './pages/APICampaignsPage.vue';
import CampaignReportPage from './pages/Reports/CampaignReportPage.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator', 'campaigns_manage'],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'campaigns_ongoing_index', params: to.params };
          },
        },
        {
          path: 'ongoing',
          name: 'campaigns_ongoing_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_livechat_index', params: to.params };
          },
        },
        {
          path: 'one_off',
          name: 'campaigns_one_off_index',
          meta,
          redirect: to => {
            return { name: 'campaigns_whatsapp_index', params: to.params };
          },
        },
        {
          path: 'live_chat',
          name: 'campaigns_livechat_index',
          meta,
          component: LiveChatCampaignsPage,
        },
        {
          path: 'whatsapp',
          name: 'campaigns_whatsapp_index',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: WhatsAppCampaignsPage,
        },
        {
          path: 'whatsapp/reports/:campaignParam',
          name: 'campaigns_whatsapp_report',
          meta: {
            ...meta,
            featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
          },
          component: CampaignReportPage,
          props: route => ({
            listRouteName: 'campaigns_whatsapp_index',
            campaignParam: route.params.campaignParam,
          }),
        },
        {
          path: 'api',
          name: 'campaigns_api_index',
          meta,
          component: APICampaignsPage,
        },
        {
          path: 'api/reports/:campaignParam',
          name: 'campaigns_api_report',
          meta,
          component: CampaignReportPage,
          props: route => ({
            listRouteName: 'campaigns_api_index',
            campaignParam: route.params.campaignParam,
          }),
        },
      ],
    },
  ],
};

export default campaignsRoutes;
